import GlobalStyle from "./globalStyles";
import Home from "./pages/HomePage/Home";
import { Footer, Navbar } from "./components";
import { useState } from "react";

function App() {
  const [lightTheme, setlightTheme] = useState(true);

  return (
    <div className="App">
      <GlobalStyle />
      <Navbar light={lightTheme} setlight={setlightTheme} />
      <Home light={lightTheme} />
      <Footer light={lightTheme} />
    </div>
  );
}

export default App;
